import { z } from 'zod';

/**
 * Razze "standard" suggerite dal manuale draft (riga 1761):
 * umani, nani, elfi, halfling e mezz'orchi.
 *
 * Il manuale chiarisce esplicitamente che il giocatore NON è limitato a queste:
 * può proporre razze custom (goblin, golem, fungo parlante…), discutendole
 * con il GM e il gruppo. Lo schema rispetta questa libertà tramite il
 * discriminated union sotto.
 */
export const StandardRaceSchema = z.enum(['umano', 'nano', 'elfo', 'halfling', 'mezzorco']);
export type StandardRace = z.infer<typeof StandardRaceSchema>;

export const STANDARD_RACES = StandardRaceSchema.options;

/**
 * Scelta della razza del PG: una delle 5 standard, oppure custom narrativa.
 *
 * - `kind: 'preset'` → razza dalla lista standard (con archetipo associato per default)
 * - `kind: 'custom'` → razza custom; il giocatore comunque sceglie un Archetipo
 *   tra quelli disponibili per la sua classe (vedi manuale: "scegli pure
 *   l'archetipo che preferisci").
 */
export const RaceChoiceSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('preset'),
    id: StandardRaceSchema,
  }),
  z.object({
    kind: z.literal('custom'),
    name: z.string().min(1).max(50),
  }),
]);
export type RaceChoice = z.infer<typeof RaceChoiceSchema>;
